module.exports = __webpack_public_path__ + "img/Facebook_Icon.d2e6a4b4.png";